import { memo } from "react";

import { StaticPriceWeekdaySettings } from "./weekday-settings/weekday-settings";
import { StaticPriceWeekendSettings } from "./weekend-settings/weekend-settings";

import type { OverSiteControllerPeopleNumType } from "../_hooks/use-over-site-controller-people-num-type";

const DescriptionComponent = memo(() => {
	return (
		<div className="my-8 rounded bg-zinc-100 p-4 text-sm leading-6">
			手間いらずやねっぱん！をご利用の場合、<b>6人まで</b>
			サイトコントローラーから料金を設定することが可能です。
			超過人数に対する追加の料金の設定は、以下の説明に沿って行なってください。
			<div className="p-2">
				ex.1) <b>7人目の料金を10,000円にしたい場合</b> <br />
				<div className="pt-1" />
				→ 設定上限から、宿泊の合計人数が「7」名様まで、お一人様あたり10,000円
				<br />
			</div>
			<div className="p-2">
				ex.2) <b>7人目、8人目の料金を、それぞれ12,000円にしたい場合</b>
				<br />
				<div className="pt-1" />
				→ 設定上限から、宿泊の合計人数が「8」名様まで、お一人様あたり12,000円
				<br />
			</div>
			<div className="p-2">
				ex.3) <b>7〜8人目の料金を12,000円、9〜10人目の料金を10000円にしたい場合</b>
				<br />
				<div className="pt-1" />
				→ 設定上限から、宿泊の合計人数が「8」名様まで、お一人様あたり12,000円
				<br />
				<span className="mx-2" />
				9名様から「10」名様まで、お一人様あたり10,000円
			</div>
		</div>
	);
});

type Props = {
	overSiteControllerPeopleNumType: OverSiteControllerPeopleNumType;
};

export const StaticPriceSettings = ({ overSiteControllerPeopleNumType }: Props) => {
	return (
		<>
			{overSiteControllerPeopleNumType === "StaticPrice" && (
				<>
					<DescriptionComponent />
					<div className="space-y-12">
						<StaticPriceWeekendSettings />
						<StaticPriceWeekdaySettings />
					</div>
				</>
			)}
		</>
	);
};
